const mega_menu = (function() {
  const mega_menus = document.getElementsByClassName('mega-menu');

  // Do not close mega menu if it is clicked
  for (let i = 0; i < mega_menus.length; i++) {
    mega_menus[i].addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }
})();

export default mega_menu;
